<template>
	<input 
		type="text" 
		class="input_type1" 
		:value="internalValue"
		@input="updateValue"
		:placeholder="placeholder"
	/>
</template>

<script>
export default {
	props: {
		modelValue: {
			type: String,
			default: "",
		},
		placeholder: String,
	},
	data() {
		return {
			internalValue: this.modelValue,
		};
	},
	watch: {
		// modelValue가 변경되면 internalValue도 업데이트
		modelValue(newValue) {
			this.internalValue = newValue;
		},
	},
	methods: {
		updateValue(event) {
			this.$emit("update:modelValue", event.target.value); // 부모에게 새로운 값을 전달
		},
	},
}
</script>
